// Lets the non-React API client trigger a permissions refetch; throttled so a
// burst of 403s can't loop.
class PermissionsRefreshManager {
  private listeners: Set<() => void> = new Set();
  private lastTriggeredAt = 0;
  private readonly cooldownMs = 10_000;

  addListener(callback: () => void) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  requestRefetch(force = false) {
    if (this.listeners.size === 0) return;
    const now = Date.now();
    if (!force && now - this.lastTriggeredAt < this.cooldownMs) {
      return;
    }
    this.lastTriggeredAt = now;
    this.listeners.forEach((callback) => callback());
  }
}

export const permissionsRefreshManager = new PermissionsRefreshManager();
export default permissionsRefreshManager;
